<section class="section get-started">
  <div class="container">
    <div class="section-heading text-center">
      <h2 class="extra-bold">All-in-one Marketing Solution</h2>
      <p class="lead color2">
        <span class="text-primary">Everything you need in one solution</span>,
        introducing Marketing Automation Tool, a powerful product for growing
        your business.
      </p>
    </div>

    <div class="pb-8 position-relative">
      <div class="browser shadow-lg mx-auto" data-aos="fade-up">
        <div class="screen">
          <img
            src="assets/img/screens/dash/4.png"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>

      <div class="floating-box bg-contrast">
        <!-- data-aos="fade-right" -->
        <div class="p-4 p-lg-5 shadow-lg rounded text-center">
          <p class="lead regular">
            Communicate better, put all your customer information in one single
            place, get insights ans stats in a nutshell
          </p>

          <p class="handwritten highlight font-md mt-5">
            No credit card needed
          </p>
          <a href="javascript:;" class="btn btn-rounded btn-lg btn-primary">
            Start Now
          </a>

          <hr class="w-50 mx-auto my-4" />
          <p class="small text-secondary">
            By registering you will get 14 days of free access to the full
            featured solution
          </p>
        </div>
      </div>

      <dc-modal-video [identifier]="'myModal'" [videoId]="'MXghcI8hcWU'">
        <span
          class="play-video btn btn-primary btn-circle text-contrast shadow"
        >
          <fa-icon [icon]="play" [class]="'font-lg'"></fa-icon>
        </span>
      </dc-modal-video>
    </div>
  </div>
</section>
